import { render, staticRenderFns } from "./semantic_help.vue?vue&type=template&id=1bd5ad18&scoped=true&lang=html"
import script from "./semantic_help.vue?vue&type=script&lang=js"
export * from "./semantic_help.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd5ad18",
  null
  
)

export default component.exports